import React, { Component } from 'react';
import './Board.css'
import PropTypes from 'prop-types';

class Board extends Component {

    constructor(props) {
        super(props);

        this.state = {
            peeked: props.cellsClicked ? props.cellsClicked.map(() => false) : [],
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.cellsClicked !== this.props.cellsClicked) {
            const nextPeeked = this.props.cellsClicked.map((clicked, idx) => {
                if (!clicked) {
                    return false;
                }
                return this.state.peeked[idx] || false;
            });

            if (!this.arraysEqual(nextPeeked, this.state.peeked)) {
                this.setState({ peeked: nextPeeked });
            }
        }
    }

    arraysEqual(a = [], b = []) {
        if (a.length !== b.length) {
            return false;
        }
        for (let i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) {
                return false;
            }
        }
        return true;
    }

    handleCellClick(i) {
        const { isPlayer, cellsClicked, revealCell } = this.props;
        const isGuessed = cellsClicked[i];

        if (!isGuessed) {
            if (isPlayer) {
                revealCell(i);
            }
            return;
        }

        this.setState(prevState => {
            const peeked = prevState.peeked.slice();
            peeked[i] = !peeked[i];
            return { peeked };
        });
    }

    /** Renders a single cell (card) on the board */
    renderCell(i) {
        const isGuessed = this.props.cellsClicked[i];
        const isPeeked = this.state.peeked[i];
        const guessedBy = this.props.guessedBy
            ? this.props.guessedBy[i]
            : null;

        let classname = "cell ";
        classname += "dark-cell ";

        if (!isGuessed) {
            if (!this.props.isPlayer) {
                classname += this.props.layout[i] + "-box ";
                classname += "team-border team-border-" + this.props.layout[i] + " ";
                classname += "disabled ";
            }
        } else {
            if (!isPeeked) {
                classname += this.props.layout[i] + "-box ";
            }
            classname += "team-border team-border-" + this.props.layout[i] + " ";
            if (isPeeked) {
                classname += "peeked ";
            } else {
                classname += "covered ";
            }
        }
        return (
            <div className={classname} key={i.toString()} onClick={() => {this.handleCellClick(i)}}>
                {(!isGuessed || isPeeked) && <img className="gif" key={i.toString()} src={this.props.gifs[i]} alt="" />}
                {isGuessed && guessedBy && (
                    <div className={"guess-indicator guess-indicator-" + guessedBy} />
                )}
            </div>
        );
    }

    render() {
        let cells = [];
        for (let cell = 0; cell < this.props.cellsClicked.length; cell++) {
            cells.push(this.renderCell(cell))
        }
        return <div className="board">{cells}</div>;
    }

}

Board.propTypes = {
    isPlayer: PropTypes.bool,
    cellsClicked: PropTypes.array,
    guessedBy: PropTypes.array,
    layout: PropTypes.array,
    gifs: PropTypes.array,
    revealCell: PropTypes.func,
};

export default Board;
